/* unplugin-vue-components disabled */import { render } from "./AuthItemsAttributeMappingDialog.vue?vue&type=template&id=1edb4f1f&scoped=true&ts=true"
import script from "./AuthItemsAttributeMappingDialog.vue?vue&type=script&lang=ts"
export * from "./AuthItemsAttributeMappingDialog.vue?vue&type=script&lang=ts"

import "./AuthItemsAttributeMappingDialog.vue?vue&type=style&index=0&id=1edb4f1f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edb4f1f"]])

export default __exports__